import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
import { AcceptAssignmentResponse, Attendee } from '../../../core';
export var ASSIGNMENT_API = 'ASSIGNMENT_API';
export var AssignmentApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(AssignmentApi, _AxiosApi);

  var _super = _createSuper(AssignmentApi);

  function AssignmentApi(axiosInstance, assignmentSummaryWebMapper) {
    var _this;

    _classCallCheck(this, AssignmentApi);

    _this = _super.call(this, 'assignments', axiosInstance);
    _this.axiosInstance = axiosInstance;
    _this.assignmentSummaryWebMapper = assignmentSummaryWebMapper;
    return _this;
  }

  _createClass(AssignmentApi, [{
    key: "complete",
    value: function () {
      var _complete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.post("".concat(this.url, "/").concat(id, "/complete"));

              case 3:
                return _context.abrupt("return", Result.ok());

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function complete(_x) {
        return _complete.apply(this, arguments);
      }

      return complete;
    }()
  }, {
    key: "getAssignmentsForResponder",
    value: function () {
      var _getAssignmentsForResponder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(queryParams) {
        var jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.axios.get(this.url, {
                  params: queryParams
                });

              case 3:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", Result.fail(parsedResponseBody.message));

              case 7:
                return _context2.abrupt("return", Result.ok(parsedResponseBody.data));

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function getAssignmentsForResponder(_x2) {
        return _getAssignmentsForResponder.apply(this, arguments);
      }

      return getAssignmentsForResponder;
    }()
  }, {
    key: "getAssignments",
    value: function () {
      var _getAssignments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(queryParams) {
        var _this2 = this;

        var url, jsonResponse, parsedResponseBody, mapped, combinedOrError;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                url = "".concat(this.url, "/search");
                _context3.next = 4;
                return this.axios.get(url, {
                  params: queryParams
                });

              case 4:
                jsonResponse = _context3.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", Result.fail(parsedResponseBody.message));

              case 8:
                mapped = parsedResponseBody.data.items.map(function (item) {
                  return _this2.assignmentSummaryWebMapper.toDomain(item);
                });
                combinedOrError = Result.combineArray(mapped);

                if (!combinedOrError.isFailure) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return", Result.fail(combinedOrError.error));

              case 12:
                return _context3.abrupt("return", Result.ok({
                  data: combinedOrError.getValue(),
                  nextToken: parsedResponseBody.data.nextToken
                }));

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 15]]);
      }));

      function getAssignments(_x3) {
        return _getAssignments.apply(this, arguments);
      }

      return getAssignments;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, submissionId) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                url = "".concat(this.url, "/").concat(id);
                _context4.next = 4;
                return this.axios.get(url, {
                  params: submissionId ? {
                    submissionId: submissionId
                  } : undefined
                });

              case 4:
                jsonResponse = _context4.sent;
                parsedResponseBody = jsonResponse.data;
                return _context4.abrupt("return", Result.ok(parsedResponseBody.data));

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 9]]);
      }));

      function getById(_x4, _x5) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
        var url;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                url = "".concat(this.url, "/").concat(id);
                _context5.next = 4;
                return this.axios["delete"](url);

              case 4:
                return _context5.abrupt("return", Result.ok());

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", ErrorResultHandler(_context5.t0));

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function _delete(_x6) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(useCaseInput) {
        var _id, _input, url;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _id = useCaseInput.id, _input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(_id);
                _context6.next = 5;
                return this.axios.patch(url, _input);

              case 5:
                return _context6.abrupt("return", Result.ok());

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", ErrorResultHandler(_context6.t0));

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 8]]);
      }));

      function update(_x7) {
        return _update.apply(this, arguments);
      }

      return update;
    }() // Attendee

  }, {
    key: "createAttendee",
    value: function () {
      var _createAttendee = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(useCaseInput) {
        var assignmentId, _input2, url, jsonResponse, parsedBodyResponse;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                assignmentId = useCaseInput.assignmentId, _input2 = useCaseInput.input;
                url = "".concat(this.url, "/").concat(assignmentId, "/attendees");
                _context7.next = 5;
                return this.axios.post(url, _input2);

              case 5:
                jsonResponse = _context7.sent;
                parsedBodyResponse = jsonResponse.data;
                return _context7.abrupt("return", AcceptAssignmentResponse.create(parsedBodyResponse.data));

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", ErrorResultHandler(_context7.t0));

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 10]]);
      }));

      function createAttendee(_x8) {
        return _createAttendee.apply(this, arguments);
      }

      return createAttendee;
    }()
  }, {
    key: "getAttendees",
    value: function () {
      var _getAttendees = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(useCaseInput) {
        var assignmentId, _queryParams, url, jsonResponse, parsedResponseBody, responses;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                assignmentId = useCaseInput.assignmentId, _queryParams = useCaseInput.queryParams;
                url = "".concat(this.url, "/").concat(assignmentId, "/attendees");
                _context8.next = 5;
                return this.axios.get(url, {
                  params: _queryParams
                });

              case 5:
                jsonResponse = _context8.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context8.next = 9;
                  break;
                }

                return _context8.abrupt("return", Result.fail(parsedResponseBody.message));

              case 9:
                responses = parsedResponseBody.data.map(function (props) {
                  return Attendee.fromJson(props).getValue();
                });
                return _context8.abrupt("return", Result.ok(responses));

              case 13:
                _context8.prev = 13;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", ErrorResultHandler(_context8.t0));

              case 16:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 13]]);
      }));

      function getAttendees(_x9) {
        return _getAttendees.apply(this, arguments);
      }

      return getAttendees;
    }()
  }, {
    key: "getAttendeeById",
    value: function () {
      var _getAttendeeById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(useCaseInput) {
        var assignmentId, attendeeId, url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                assignmentId = useCaseInput.assignmentId, attendeeId = useCaseInput.attendeeId;
                url = "".concat(this.url, "/").concat(assignmentId, "/attendees/").concat(attendeeId);
                _context9.next = 5;
                return this.axios.get(url);

              case 5:
                jsonResponse = _context9.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context9.next = 9;
                  break;
                }

                return _context9.abrupt("return", Result.fail(parsedResponseBody.message));

              case 9:
                return _context9.abrupt("return", Attendee.fromJson(parsedResponseBody.data));

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", ErrorResultHandler(_context9.t0));

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 12]]);
      }));

      function getAttendeeById(_x10) {
        return _getAttendeeById.apply(this, arguments);
      }

      return getAttendeeById;
    }()
  }, {
    key: "verifyPassword",
    value: function () {
      var _verifyPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(input) {
        var url;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                url = "".concat(this.url, "/").concat(input.assignmentId, "/verify-password");
                _context10.next = 4;
                return this.axios.post(url, {
                  password: input.password
                });

              case 4:
                return _context10.abrupt("return", Result.ok());

              case 7:
                _context10.prev = 7;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", ErrorResultHandler(_context10.t0));

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 7]]);
      }));

      function verifyPassword(_x11) {
        return _verifyPassword.apply(this, arguments);
      }

      return verifyPassword;
    }()
  }]);

  return AssignmentApi;
}(AxiosApi);